import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { SvgLine } from '@tmapy/style-guide';
import { calculateLineMeasurements } from '@tmapy/mapcore';
import { useMessage } from '@tmapy/intl';
import { SegmentMeasurement } from './SegmentMeasurement';
import { MeasurementHeader } from './MeasurementHeader';
import { measureMessages } from './measureMessages';
export const LineStringMeasurement = ({ feature, lineString, projection, dispatch, }) => {
    const formatMessage = useMessage();
    const measurements = calculateLineMeasurements(lineString, projection);
    const lastSegment = measurements[measurements.length - 1];
    return (_jsxs(_Fragment, { children: [_jsx(MeasurementHeader, { icon: _jsx(SvgLine, {}), label: formatMessage(measureMessages.measureLength), value: `${lastSegment.cumulativeSumFormat} ${lastSegment.cumulativeSumUnits}`, feature: feature, projection: projection, dispatch: dispatch }), _jsx(SegmentMeasurement, { segments: measurements })] }));
};
//# sourceMappingURL=LineStringMeasurement.js.map